import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  apellido_paterno: z.string().min(3, 'El apellido paterno debe tener al menos 3 caracteres',),
  apellido_materno: z.string().min(3, 'El apellido materno debe tener al menos 3 caracteres',),
  correo: z.string().email('El correo debe ser un correo electrónico válido'),
  telefono: z.string().min(10, 'El teléfono debe tener al menos 10 caracteres'),
/*   sucursales: z.array(z.object({
    label: z.string()
  })).nonempty('Debes tener al menos una sucursal'), */
})